import { useCallback, useState, } from "react";
import { Drawer, Button, Space, Radio, message } from "antd";
import { MobileOutlined, DesktopOutlined, ArrowLeftOutlined, SettingOutlined } from "@ant-design/icons";
import { useEditorContext } from "./EditorContext";

const MobileBG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="342"
      height="612"
      viewBox="0 0 342 612"
    >
      <g
        fill="none"
        fillRule="evenodd"
        transform="translate(1 1)"
      >
        <rect
          width="340"
          height="610"
          fill="#FFF"
          stroke="#979797"
          rx="33">
        </rect>
        <circle cx="170" cy="577" r="25" fill="#FBFBFB" stroke="#C4C4C4"></circle>
        <g transform="translate(126 27)">
          <circle cx="4.5" cy="4.5" r="4.5" fill="#FBFBFB" stroke="#C4C4C4"></circle>
          <path fill="#C4C4C4" d="M23.503 0h40.994A4.505 4.505 0 0 1 69 4.5C69 6.985 66.978 9 64.497 9H23.503A4.505 4.505 0 0 1 19 4.5C19 2.015 21.022 0 23.503 0Zm0 2h40.994A2.505 2.505 0 0 1 67 4.5C67 5.878 65.876 7 64.497 7H23.503A2.505 2.505 0 0 1 21 4.5C21 3.122 22.124 2 23.503 2Z"></path>
          <path fill="#FBFBFB" d="M22.612 1h42.776C66.828 1 68 2.572 68 4.5 68 6.43 66.827 8 65.388 8H22.612C21.172 8 20 6.428 20 4.5 20 2.57 21.173 1 22.612 1Z"></path>
        </g>
      </g>
    </svg>
    )
}

export default () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewDevice, setPreviewDevice] = useState("desktop");
  const { editorRef, hideHeader } = useEditorContext();
  const [html, setHtml] = useState()

  const showModal = useCallback(() => {
    const htmlFile = editorRef.current.getHTML(true);
    // for preview page handle, and make sure change every time.
    const currentTimestamp: number = Date.now();
    const previewHtmlFile = `
      ${htmlFile}
      <script>
        sessionStorage.setItem('isPreviewMode', ${currentTimestamp});
      </script>
    `;
    setHtml(previewHtmlFile);
    setIsModalOpen(true);
  }, []);


  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const onChangePreviewDevice = useCallback((e) => {
    setPreviewDevice(e.target.value);
  }, [])

  const detectFormSubmitButtonCount = (jsonFile: Record<string, any>): object => {
    // this function for count form submit button number.
    var formSubmitButtonNumberObj = { "submit": 0, "reset": 0, "close": 0};
    const children1 = jsonFile["children"] || [];
    for (const item of children1) {
      const children2 = item["children"] || [];
      for (const item2 of children2) {
        for (const item3 of (item2["children"] || [])) {
          const item3Type = item3["type"];
          if (item3Type == "form-submit-button") {
            const action = item3["data"]?.["action"];
            if (action) {
              formSubmitButtonNumberObj[action] = (formSubmitButtonNumberObj[action] ?? 0)+ 1;
            }
          }
        }
      }
    }
    return formSubmitButtonNumberObj;
  }

  const detectFormType = (jsonFile: Record<string, any>): boolean => {
    // this function can detect form type or not.
    const children = jsonFile["children"] || [];
    for (const item of children) {
      const children2 = item["children"] || [];
      for (const item2 of children2) {
        for (const item3 of (item2["children"] || [])) {
          const item3Type = item3["type"];
          if (item3Type && item3Type.startsWith("form-") && item3Type !== "form-submit-button" && item3Type !== "form-thankyou") {
            return true;
          }
        }
      }
    }
    return false;
  }

  const checkFormSubmitButtonReasonable = (jsonFile: Record<string, any>): string => {
    // this function for check json file form submit button reasonable
    const formSubmitButtonNumberObj = detectFormSubmitButtonCount(jsonFile);
    const hasFormComponent = detectFormType(jsonFile);
    if (hasFormComponent) {
      if (formSubmitButtonNumberObj["submit"] === 0){
        return "Form component requires at least one form submit button"
      } else if (formSubmitButtonNumberObj["submit"] > 1) {
        return "Multiple form submit buttons are not allowed";
      }
    } else {
      if (formSubmitButtonNumberObj["submit"] > 0) {
        return "Form submit button is not allowed without form component"; 
      }
      if (formSubmitButtonNumberObj["reset"] > 0) {
        return "Form reset button is not allowed without form component"; 
      }
      if (formSubmitButtonNumberObj["close"] > 0) {
        return "Form close button is not allowed without form component"; 
      }
    }
    return "";
  }

  const handleSave = useCallback(() => {
    const jsonFile = editorRef.current.getJSON();
    const htmlFile = editorRef.current.getHTML();
    const checkStatus = checkFormSubmitButtonReasonable(jsonFile);
    if (!checkStatus) {
      window.parent.postMessage({ type: "save", jsonFile, htmlFile },'*')
    } else {
      message.error(checkStatus);
    }
  }, []);

  const handleSaveAndClose =  useCallback(() => {
    const jsonFile = editorRef.current.getJSON();
    const htmlFile = editorRef.current.getHTML();
    const checkStatus = checkFormSubmitButtonReasonable(jsonFile);
    if (!checkStatus) {
      window.parent.postMessage({ type: "saveAndClose", jsonFile, htmlFile, },'*')
    } else {
      message.error(checkStatus);
    }
  }, []);

  const handelBack = useCallback(() => {
    window.parent.postMessage({ type: "back" },'*')
  }, []);

  const handlePropertiesUpdate = useCallback(() => {
    window.parent.postMessage({ type: "propertiesUpdate",},'*');
  }, [])

  let iframeStyle;
  if (previewDevice === "desktop") {
    iframeStyle = {
      height:"100%",
      width: "100%",
      minWidth:1024,
      border:0,
    };
  } else {
    iframeStyle = {
      height: 478,
      width: 320,
      minWidth:320,
      border: "1px solid #cccccc",
      top: 60,
      position: "absolute",
    };
  }

  return (
    <>
      <div className="header" style={{display: hideHeader ? "none" : "flex"}}>
        <div style={{
          display: "flex",
          padding: 10,
        }}>
          <Button type="text" icon={<ArrowLeftOutlined />} onClick={handelBack}>Back</Button> 
        </div>
        <div style={{ padding: 10 }}>
          <Space>
            <Button onClick={handlePropertiesUpdate}>
              <SettingOutlined /> Page Properties
            </Button>
            <Button onClick={showModal}>Preview</Button>
            <Button type="primary" onClick={handleSave}>Save</Button>
            <Button type="primary" onClick={handleSaveAndClose}>Save & Close</Button>
          </Space>
        </div>
      </div>
      <Drawer
        title="Preview"
        placement={"top"}
        width={"100%"}
        height={"100%"}
        onClose={handleCancel}
        visible={isModalOpen}
        extra={
          <Radio.Group
            value={previewDevice}
            onChange={onChangePreviewDevice}
            buttonStyle="solid"
            style={{display: "flex", justifyContent: "end", minWidth: 250}}
          >
            <Radio.Button value="desktop"><DesktopOutlined />&nbsp;Desktop</Radio.Button>
            <Radio.Button value="mobile"><MobileOutlined />&nbsp;Mobile</Radio.Button>
          </Radio.Group>
        }
      >
        <div style={{height: "100%", display: "flex", justifyContent: "center", position: "relative"}}>
          { previewDevice === "mobile" && <MobileBG /> } 
          <iframe
            srcDoc={html}
            style={iframeStyle}
          />
        </div>
      </Drawer>
    </>
  );
};
